'use client';

import FeaturePanel from './FeaturePanel';
import Feature from './Feature';
export default FeaturePanel;
export { Feature as FeaturePanelFeature };